import React from 'react';
import { Alert, Snackbar } from '@mui/material';

const SendSnackbar = ({ snackbar, onClose }) => {
  return (
    <Snackbar
      key={snackbar.key}
      open={snackbar.open}
      autoHideDuration={8000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      sx={{ zIndex: (theme) => (theme?.zIndex?.modal || 1300) + 300 }}
    >
      <Alert onClose={onClose} severity={snackbar.severity} variant="filled" sx={{ width: '100%' }}>
        {snackbar.message}
      </Alert>
    </Snackbar>
  );
};

export default SendSnackbar;
